<section class="iam-screen esia-callback">
  <app-loader class="centered centered_absolute"></app-loader>
</section>
